import {
  ArnConditionsPayload,
  HasArianeeSmartAssetCondition,
  SpkzCondition,
  SpkzStrategy,
} from '@arianee/arn-types';
import { ArnConditionService } from '../ArnConditionService';
import { ArnArianeeNftConditionService } from './ArnArianeeNftConditionService';
import { ArnDelegateConditionService } from '../ArnDelegateConditionService';

export class DefaultArianeeNftConditionService
  extends ArnDelegateConditionService
  implements ArnArianeeNftConditionService
{
  static readonly CONDITION_HAS_TAG = 'hasTag';

  constructor(condition: ArnConditionService) {
    super(condition);
  }

  async hasNftWithTags(...tags: string[]): Promise<boolean> {
    const hasTagsCondition = new HasArianeeSmartAssetCondition({
      name: DefaultArianeeNftConditionService.CONDITION_HAS_TAG,
      tags,
    });
    const conditionsPayload: ArnConditionsPayload = {
      and: [hasTagsCondition],
    };
    const result = await this.condition.execute(conditionsPayload);
    return result.success;
  }

  async isSpkzVerified(spec: string | SpkzStrategy[][]): Promise<boolean> {
    const opts =
      typeof spec === 'string' ? { name: spec } : { strategies: spec };
    const spkzCondition = new SpkzCondition(opts);
    const conditionsPayload: ArnConditionsPayload = {
      and: [spkzCondition],
    };
    const result = await this.condition.execute(conditionsPayload);
    return result.success;
  }
}
